"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fedopsLogger = exports.InteractionName = void 0;
var fedops_logger_1 = require("@wix/fedops-logger");
var LOGGER_ID = 'cashier-payments-sdk';
var InteractionName;
(function (InteractionName) {
    InteractionName["REQUEST_RETRY"] = "cashier-core-request-retry";
})(InteractionName = exports.InteractionName || (exports.InteractionName = {}));
exports.fedopsLogger = fedops_logger_1.create(LOGGER_ID);
//# sourceMappingURL=index.js.map